import caseStudies from './caseStudies.json';

const pngIds = [1,2,3,4,5,6,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,39,40,43];

const imageMap = {};
for (const study of caseStudies) {
  // Synced studies with a hosted image_url — use it directly
  if (study.image_url) {
    imageMap[study.id] = study.image_url;
  } else {
    const ext = pngIds.includes(study.id) ? 'png' : 'jpg';
    imageMap[study.id] = `${process.env.PUBLIC_URL}/images/cs_${study.id}.${ext}`;
  }
}

export default imageMap;
